import DictionaryIcon_Trans from "../../../assets/UI/DictionaryIcon_Trans.png";
import SearchBarDictionary from "../DictionaryComponents/SearchBar_Dictionary/SearchBar_Dictionary";
import "../Dictionary.css";
import HeaderNavNTM from "../../../Components/Header/Header_Nav_NoBottomMargin/Header_Nav_NBM";

//Word Grids
import WordGridLarge from "../DictionaryComponents/WordGrid/WordGridLarge";

//Arrays from Subject Data
import { SubjectPronounsFormal } from "../../../SubjectData/BasicWords/Pronouns";
import { SubjectPronounsInformal } from "../../../SubjectData/BasicWords/Pronouns";
import { ObjectPronounsFormal } from "../../../SubjectData/BasicWords/Pronouns";
import { ObjectPronounsInformal } from "../../../SubjectData/BasicWords/Pronouns";
import { PossessivePronounsFormal } from "../../../SubjectData/BasicWords/Pronouns";
import { PossessivePronounsInformal } from "../../../SubjectData/BasicWords/Pronouns";
import { ReflexivePronounsFormal } from "../../../SubjectData/BasicWords/Pronouns";
import { ReflexivePronounsInformal } from "../../../SubjectData/BasicWords/Pronouns";
import { DemonstrativePronounsFormal } from "../../../SubjectData/BasicWords/Pronouns";
import { DemonstrativePronounsInformal } from "../../../SubjectData/BasicWords/Pronouns";
import { InterrogativePronounsFormal } from "../../../SubjectData/BasicWords/Pronouns";
import { InterrogativePronounsInformal } from "../../../SubjectData/BasicWords/Pronouns";
import { IndefinitePronounsFormal } from "../../../SubjectData/BasicWords/Pronouns";
import { IndefinitePronounsInformal } from "../../../SubjectData/BasicWords/Pronouns";


import Popup from "../../../Components/Popup/Dictionary_Popup";
import {useState} from "react";

export default function PronounsDictionary(){

    const [openPopup, setOpenPopup] = useState(null);

    const allData = [
        ...SubjectPronounsFormal, 
        ...SubjectPronounsInformal,
        ...ObjectPronounsFormal,
        ...ObjectPronounsInformal,
        ...PossessivePronounsFormal,
        ...PossessivePronounsInformal,
        ...ReflexivePronounsFormal,
        ...ReflexivePronounsInformal,
        ...DemonstrativePronounsFormal,
        ...DemonstrativePronounsInformal,
        ...InterrogativePronounsFormal,
        ...InterrogativePronounsInformal,
        ...IndefinitePronounsFormal,
        ...IndefinitePronounsInformal
    ];
    
        return(
       
               <div>
                   <HeaderNavNTM GoBack_to="/PronounsNav"/>
                   <div className="blue-header-dict">
                       
                       <img className="DictionaryImage" src={DictionaryIcon_Trans} alt="Dictionary"></img>
                      
                         <SearchBarDictionary data={allData} onSelectItem={setOpenPopup} />
                       
                   </div>
       
                   <div>
                       
                        <WordGridLarge
                            data={SubjectPronounsFormal}
                            title="Subject Pronouns (Formal)"
                            onSelectItem={setOpenPopup}
                        />
                        <WordGridLarge
                            data={SubjectPronounsInformal}
                            title="Subject Pronouns (Informal)"
                            onSelectItem={setOpenPopup}
                        />

                        <WordGridLarge
                            data={ObjectPronounsFormal}
                            title="Object Pronouns (Formal)"
                            onSelectItem={setOpenPopup}
                        />
                        <WordGridLarge
                            data={ObjectPronounsInformal}
                            title="Object Pronouns (Informal)"
                            onSelectItem={setOpenPopup}
                        />

                        <WordGridLarge
                            data={PossessivePronounsFormal}
                            title="Possessive Pronouns (Formal)"
                            onSelectItem={setOpenPopup}
                        />
                        <WordGridLarge
                            data={PossessivePronounsInformal}
                            title="Possessive Pronouns (Informal)"
                            onSelectItem={setOpenPopup}
                        />

                        <WordGridLarge
                            data={ReflexivePronounsFormal}
                            title="Reflexive Pronouns (Formal)"
                            onSelectItem={setOpenPopup}
                        />
                        <WordGridLarge
                            data={ReflexivePronounsInformal}
                            title="Reflexive Pronouns (Informal)"
                            onSelectItem={setOpenPopup}
                        />

                        <WordGridLarge
                            data={DemonstrativePronounsFormal}
                            title="Demonstrative Pronouns (Formal)"
                            onSelectItem={setOpenPopup}
                        />
                        <WordGridLarge
                            data={DemonstrativePronounsInformal}
                            title="Demonstrative Pronouns (Informal)"
                            onSelectItem={setOpenPopup}
                        />

                        <WordGridLarge
                            data={InterrogativePronounsFormal}
                            title="Interrogative Pronouns (Formal)"
                            onSelectItem={setOpenPopup}
                        />
                        <WordGridLarge
                            data={InterrogativePronounsInformal}
                            title="Interrogative Pronouns (Informal)"
                            onSelectItem={setOpenPopup}
                        />

                        <WordGridLarge
                            data={IndefinitePronounsFormal}
                            title="Indefinite Pronouns (Formal)"
                            onSelectItem={setOpenPopup}
                        />
                        <WordGridLarge
                            data={IndefinitePronounsInformal}
                            title="Indefinite Pronouns (Informal)"
                            onSelectItem={setOpenPopup}
                        />
                       <Popup item={openPopup} onClose={() => setOpenPopup(null)} />
                  
                   </div>
                   
               </div>
       
           );
       
       }
       
    
    
    //Resources
        //Making a search bar
            //https://builtin.com/articles/react-search-bar